/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Task_Cancel_Activity_DescriptionInputs */

const en_task_cancel_activity_description = /** @type {(inputs: Task_Cancel_Activity_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The activity will stop. Pending reminders will be canceled.`)
};

const pt_br2_task_cancel_activity_description = /** @type {(inputs: Task_Cancel_Activity_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A atividade será interrompida. Os lembretes pendentes serão cancelados.`)
};

/**
* | output |
* | --- |
* | "The activity will stop. Pending reminders will be canceled." |
*
* @param {Task_Cancel_Activity_DescriptionInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const task_cancel_activity_description = /** @type {((inputs?: Task_Cancel_Activity_DescriptionInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Task_Cancel_Activity_DescriptionInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_task_cancel_activity_description(inputs)
	return pt_br2_task_cancel_activity_description(inputs)
});